export default __webpack_public_path__ + "static/media/fire.67f327a0.svg";